import React from 'react';
import styles from './Title.module.css';

const TitleMain = ({ text }) => {
    return (
        <h1 className={styles.mainTitle}>
            <span>{text}</span>
        </h1>
    );
};

export default TitleMain;
